import React, { useEffect, useState, useContext, useRef, useCallback, useMemo } from "react";
import Web3 from "web3";
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
//import { Button } from 'primereact/button';
import { useWeb3React } from "@web3-react/core";

import ContractContext from '../ContractContext';
import DataContext from "../DataContext";

import RadarSplashLogo from '../imgs/RadarSplashLogo.png'
import { getTokenPrice } from '../utils';
import Wallet from "./subcomponents_radar/Wallet";
import { Loading } from "@nextui-org/react";

import BigNumber from 'bignumber.js'

const styles =  () => ({
    splashContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start', // Changed to flex-start to align items to the top
      alignItems: 'center',
      background: '#2D2D2D',
      borderRadius: '24px',
      paddingBottom: '20px',
      boxSizing: 'border-box',
      position: 'relative', // Added to position elements absolutely inside
    },
    header: {
      color: 'black',
      fontSize: '1.8em',
      //fontFamily: 'Inter',
      fontWeight: '700',
      textAlign: 'center',
      wordWrap: 'break-word',
      marginBottom: '40px', // Increased margin
      maxWidth: '80%', // Ensure the header text doesn't span the full width
    },
    stepContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start', // Changed to flex-start to align items to the left
      width: '100%',
      gap: '20px', // Increased gap for better spacing
      //marginBottom: '40px', // Increased margin
    },
    stepTitle: {
      color: 'rgba(247, 247, 247, 0.4)',
      fontSize: '2.2em',
      //fontFamily: 'Inter',
      fontWeight: '700',
      alignSelf: 'flex-start', // Align to the start of the flex container
    },
    stepContent: {
      display: 'flex',
      alignItems: 'center', // Adjusted for vertical alignment
      flexDirection: 'row',
      gap: '10px',
    },
    stepIcon: {
      width: '45px',
      height: '45px',
      position: 'absolute',
      top: '0', // Align icons to the top of the overlayIcons div
    },
    stepText: {
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '400',
      textAlign: 'left', // Align text to the left
    },
    overlayIcons: {
      display: 'flex',
      position: 'relative',
      // You might want to adjust the width to prevent the icons from overlapping the text
      width: '120px', // Width should be the total width of the three icons considering their overlap
      height: '45px', // Set the height to that of the icons to prevent overlap with other elements
      justifyContent: 'flex-start', // Aligns the icons to the start
    },
    step1Icon: {
      width: '45px',
      height: '45px',
      position: 'relative', // or 'static' if you don't need any special positioning
      // Other styles specific to step 1 icon
    },
    step2Icon: {
      width: '45px',
      height: '45px',
      position: 'absolute',
      top: '0', // Align icons to the top of the overlayIcons div
    },
    list: {
      listStyle: 'none',
      paddingLeft: '0px', // Set padding to 0 for custom indentation
    },
    listItem: {
      position: 'relative', // Positioned relatively to use absolute for pseudo-elements
      //paddingLeft: '1em', // Space for the bullet
      marginBottom: '0.5em', // Space between list items
      '&::before': {
        content: '"•"', // Unicode character for bullet
        color: '#FBAF00', // Custom color for the bullet, match your design
        position: 'absolute', // Positioned absolutely to place it on the left of the item
        left: '0', // Align to the left
      },
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '400',
    },
    listItemBold: {
      position: 'relative', // Positioned relatively to use absolute for pseudo-elements
      paddingLeft: '1em', // Space for the bullet
      marginBottom: '0.5em', // Space between list items
      '&::before': {
        content: '"•"', // Unicode character for bullet
        color: '#FBAF00', // Custom color for the bullet, match your design
        position: 'absolute', // Positioned absolutely to place it on the left of the item
        left: '0', // Align to the left
      },
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '800',
    },
    dashboardAccess: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start', // This aligns items to the left
      flexWrap: 'nowrap', // Prevents the items from wrapping onto the next line
      gap: '10px', // This adds some space between the icons and the text
    },
    radarIcon: {
      left: '0',
      zIndex: '3',
    },
    refuelIcon: {
      left: '20px',
      zIndex: '2',
    },
    splashIcon: {
      left: '40px',
      zIndex: '1',
    },
  });

const RenderSplashScreen = React.memo(() => {
  
  return (
    <div style={styles.splashContainer}>

      <img src={RadarSplashLogo} alt="Radar" style={{ width: '100%', maxWidth: '500px', position: 'relative' }} />
    </div>
  );
});

// Replace pricing for specified tokens with alternate address pricing
const replacements = {
  "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  "0x904B4224acA463666E98f21cC8C54f8D423f6648": "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
  "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA": "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
  "0x3834303483f139c26bc282528aDee6b7Da103D54": "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
  "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8": "0x570a5d26f7765ecb712c0924e4de545b89fd43df",
  "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132": "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D",
  "0x2761c609f3DbA79FFb34d28ab8d9cc2FF381fD3A": "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
  "0xb014728C841D8Ccca6C236fE04B274D206cc60D0": "0xba2ae424d960c26247dd6c32edc70b295c744c43",
  "0x58291c58A2c4AEc7Ad24BaA87988dFc39f3FBC25": "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
};



  const getContractData = async (contract, account) => {
    //console.log("Fetching getContractData...");
    return await contract.methods.getRocketData(account).call();
  };

  const getTokenPoolData = async (contract, account) => {
    //console.log("Fetching getTokenPoolData...");
    return await contract.methods.getTokenPoolData(account).call();
  };

  const getTokenPoolDataPaginated = async (contract, account, batchSize = 100) => {
    try {
      const { 0: totalBatches } = await contract.methods.getTotalCalls(batchSize).call();
      const results = [];

      for (let page = 0; page < totalBatches; page++) {
        const batch = await contract.methods.getTokenPoolDataBatch(account, page).call();
        results.push(...batch);
      }

      return results;
    } catch (err) {
      console.error("getTokenPoolDataPaginated failed:", err);
      return [];
    }
  };


  const getTokenBnbValueSmartRewards = async (contract, token) => {
    return await contract.methods.getTokenBnbValueSmartRewards(token.address, true, true).call();
  };

  const getAllSmartRewardsBnbValues = async (contract) => {
    return await contract.methods.getAllSmartRewardsBnbValues().call();
  };

  const getAllSmartRewardsUsdValues = async (contract) => {
    return await contract.methods.getAllSmartRewardsUsdValues().call();
  };


export const Radar = () => {
  const { library, account, active, } = useWeb3React();
  const { contracts } = useContext(ContractContext);
  const { data, setData } = useContext(DataContext);
  const [smartCodeData, setSmartCodeData] = useState({});
  const [dbError, setDbError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [bnbBalance, setBnbBalance] = useState(0);
  const toast = useRef(null);
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bnbPrice, setBnbPrice] = useState(0);
  const [pauseRefresh, setPauseRefresh] = useState(false);

  const isWalletConnected =  () => !!account;

  const rocketFiPrice = useMemo(() => getTokenPrice(data?.tokensList, "ROCKETFI"), [data?.tokensList]);
  const [walletVisible, setWalletVisible] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [manualRefresh, setManualRefresh] = useState(false);

  const createTokensList = useCallback((tokenPoolData, pricingData) => {

    return tokenPoolData.map((tokenData) => {
      if (!tokenData) return undefined;
      const tokenAddress = tokenData._tokenAddress.toLowerCase();
      const pricingToken = pricingData[tokenAddress];
      let tokenPrice = pricingToken ? pricingToken.usd : undefined;
      return {
        value: tokenData._tokenAddress,
        label: tokenData._symbol,
        rocketFiSubscribed: tokenData._shareCount / (10 ** 9),
        totalDistributed: tokenData._totalDistributed,
        decimals: tokenData._decimals,
        poolID: tokenData._poolID,
        unclaimedAmount: tokenData._unclaimedAmount,
        claimedAmount: tokenData._claimedAmount,
        routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        address: tokenData._tokenAddress,
        price: tokenPrice,
        reflectionPoolAddress: tokenData._reflectionPoolAddress,
        balanceOfHolder: tokenData._balanceOfHolder,
        totalSupply: tokenData._totalSupply,
        name: tokenData._name,
      };
    });
  }, []);





  useEffect(() => {
    if (dbError && toast.current) {
      toast.current.show({ severity: 'warn', summary: 'Warning Message', detail: errorMessage, life: 5000 }); // display the custom error message
    }
  }, [dbError, errorMessage]);

  useEffect(() => {
    if (data?.tokensListRp) {
      setLoading(false); // Hide the loading dialog once data is available
    }
  }, [data?.tokensListRp]);

  useEffect(() => {
    if (!library) return;
    const web3 = new Web3(library.provider);
    web3.eth.getBalance(account).then((balance) => {
      //console.log("balance:", balance);
      setBnbBalance(balance);
    });
  }, [library, account]);





  //web3 calls
  const getPrimaryData = useCallback(async () => {

    // Fetch data from rocketFiOracleV1 and rocketFiOracleV2 in the background
    const [
      contractDataRpRes, tokenPoolDataRpRes] = await Promise.allSettled([
        getContractData(contracts.rp_rocketFiOracle, account),
        getTokenPoolDataPaginated(contracts.rp_rewardPacksOracle, account),
      ]);

    const contractDataRp = contractDataRpRes.status === 'fulfilled' ? contractDataRpRes.value : [];
    const tokenPoolDataRp = tokenPoolDataRpRes.status === 'fulfilled' ? tokenPoolDataRpRes.value : [];


    const activePoolAddress = [
      ...new Set(
        tokenPoolDataRp.map((obj) => obj._tokenAddress)
      ),
    ];

    const str1 = activePoolAddress.toString();

    return {
      activePoolAddress: str1,
      contractDataRp,
      tokenPoolDataRp,
    };
  }, [contracts, account]);

    //db calls
    const getDatabaseData = useCallback(async (_url, _endPoint, _parms) => {
    const data = await fetch(_url + _endPoint + "?" + _parms, {
      method: "GET",
      headers: {
      //'Authorization': bearer,
      "x-floatie-api-key": "hrNqBjEIOaMLvY7SNXQtYOca5LvlQPn6O3oduqOwg3L3up20",
      "x-floatie-api-secret": "O3Ux1HsMC8Qcd0rb",
      "Content-Type": "application/json",
      },
    });

    var jsondata = await data.json();
    return jsondata.result;
    }, []);


    const getSecondaryData = useCallback(async (activePoolAddress, _tokenPoolDataRp, pricingData) => {
    // normalize activePoolAddress to an array of addresses
    const addresses = typeof activePoolAddress === "string"
      ? activePoolAddress.split(",").map(a => a.trim()).filter(Boolean)
      : Array.isArray(activePoolAddress)
      ? activePoolAddress.slice()
      : [];

    // chunk into batches of max 100
    const BATCH_SIZE = 100;
    const batches = [];
    for (let i = 0; i < addresses.length; i += BATCH_SIZE) {
      batches.push(addresses.slice(i, i + BATCH_SIZE));
    }

    // perform fetches for each batch
    let mergedDbData = [];
    if (batches.length === 0) {
      mergedDbData = [];
    } else {
      const fetchPromises = batches.map(batch => {
      const params = "addresses=" + batch.join(",") + "&limit=" + batch.length;
      return getDatabaseData("https://api.rocketfi.app/v1/", "tokens", params);
      });

      const results = await Promise.allSettled(fetchPromises);
      // collect fulfilled results and flatten
      mergedDbData = results
      .filter(r => r.status === "fulfilled" && Array.isArray(r.value))
      .map(r => r.value)
      .flat();
    }

    if (!mergedDbData || mergedDbData.length === 0) {
      setErrorMessage("Database did not return any data"); // set custom error message when _dbData doesn't return anything
      setDbError(true);
    } else {
      const _tokensListRp = createTokensList(_tokenPoolDataRp, pricingData);
      return {
      dbData: mergedDbData,
      tokensListRp: _tokensListRp,
      };
    }
    }, [createTokensList, getDatabaseData]);

  const getPricingData = useCallback(async () => {
  const oracle = contracts.liquidityOraclePaginator;
  const BATCH_SIZE = 100;
  let pricingData = {};

  try {
    const { 0: totalBatches } = await oracle.methods.getActivePoolTotalCalls(BATCH_SIZE).call();

    for (let page = 0; page < totalBatches; page++) {
      const bnbBatch = await oracle.methods.getAllSmartRewardsBnbValuesBatch(page, BATCH_SIZE).call();
      const usdBatch = await oracle.methods.getAllSmartRewardsUsdValuesBatch(page, BATCH_SIZE).call();

      for (let i = 0; i < bnbBatch[0].length; i++) {
        const addr = bnbBatch[0][i].toLowerCase();
        const bnb = Number(bnbBatch[1][i]) / 1e18;
        const usdIndex = usdBatch[0].findIndex(x => x.toLowerCase() === addr);
        const usd = usdIndex !== -1 ? Number(usdBatch[1][usdIndex]) / 1e18 : 0;

        pricingData[addr] = { bnb, usd };
      }
    }

    // Hardcoded USD pegs
    pricingData["0x2e3b6906b976ab8da82228e0569b3ef6ea1e8cc6"] = { usd: 1.0 };
    pricingData["0x27874a586bafaf54d4cd0aae368ad9569d06d115"] = { usd: 1.0 };

    Object.entries(replacements).forEach(([original, alternate]) => {
      const orig = original.toLowerCase();
      const repl = alternate.toLowerCase();
      if (pricingData[orig] && pricingData[repl]) {
        pricingData[orig] = { ...pricingData[repl] };
      }
    });

    return { pricingData };
  } catch (err) {
    console.error("Paginated getPricingData failed:", err);
    return { pricingData };
  }
}, [contracts]);



  const getData = useCallback(async () => {
    setIsRefreshing(true);
    setLoading(true);
    if (!isWalletConnected() || !contracts || !contracts.rp_rocketFiOracle) {
      //console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }

    try {
      // get pricing data
      //console.log("Fetching pricing data...");
      const pricingData = await getPricingData();
      //console.log("Fetching pricing data completed:", pricingData);

      //console.log("Fetching primary data...");
      const primaryData = await getPrimaryData();
      //console.log("Fetching primary data completed:", primaryData);

      //console.log("Fetching database data...");
      const newData = {
        ...data,
        ...primaryData,
        ...pricingData,
      };

      setData(newData); // set the data state only once with the updated data
    } catch (err) {
      console.error("An error occurred while fetching contract data:", err);
    }
    setLoading(false);
  }, [contracts, account]);


  const getAdditionalData = useCallback(async () => {
    if (!isWalletConnected() || !contracts || !contracts.rp_rocketFiOracle) {
      //console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }

    try {
      const secondaryData = await getSecondaryData(data.activePoolAddress, data.tokenPoolDataRp, data.pricingData);
      //console.log("secondaryData:", secondaryData);
      const newData = {
        ...data,
        ...secondaryData,
      };

      setData(newData);

    } catch (err) {
      console.error("An error occurred while fetching contract data:", err);
    }
    if (manualRefresh) {
      //GetPastBurnEvents();
      setManualRefresh(false);

      setTimeout(() => {
        toast.current.show({ severity: 'success', summary: 'Data Refreshed', detail: new Date().toLocaleString(), life: 2500 });
        setIsRefreshing(false);
      }, 250);
    }
    else {
      setIsRefreshing(false);
    }

  }, [
    data?.activePoolAddress,
    data?.tokenPoolDataRp,
    data?.pricingData,
    getSecondaryData,
    isWalletConnected,
    contracts,
  ]);

  const getSmartCodeData = useCallback(async () => {
    const result = await contracts.smartCodes.methods.smartCodeData(account).call();
    //console.log("getSmartCodeData:", result);
    return result;
  }, [contracts, account]);

  useEffect(() => {
    if (isWalletConnected() && contracts) {
      getData();
    }
  }, [account, contracts, getData]);

  useEffect(() => {
    if (data?.activePoolAddress && data?.tokenPoolDataRp && data?.pricingData)
      getAdditionalData();

  }, [data?.activePoolAddress, data?.tokenPoolDataRp, data?.pricingData]);

  useEffect(() => {
    const fetchSmartCodeData = async () => {
      const result = await getSmartCodeData();
      setSmartCodeData(result);
    };

    if (data && contracts.smartCodes) {
      fetchSmartCodeData();
    }
  }, [data, contracts]);

  //returns the price for 1 BNB in USD
  const getBNBPrice = useCallback(async (contract) => {
    let value = new BigNumber('1000000000000000000');
    return await contract.methods.getBNBValueToken("0xe9e7cea3dedca5984780bafc599bd69add087d56", value.toString(), "0x10ED43C718714eb63d5aA57B78B54704E256024E").call();
  }, []);

  const fetchBNBPrice = useCallback(async () => {
    const bnbData = await getBNBPrice(contracts.liquidityOracle);

    const bnbPrice = bnbData / (10 ** 18);

    return bnbPrice;
  }, [contracts.liquidityOracle]);



  const setBNBPrice = useCallback(async () => {
    const bnbPrice = await fetchBNBPrice();
    setBnbPrice(bnbPrice);
  }, [fetchBNBPrice]);

  useEffect(() => {
    if (!contracts.liquidityOracle) return;
    setBNBPrice();
  }, [contracts.liquidityOracle, account]);

  useEffect(() => {
    if (bnbPrice > 0) {
      // console.log("BNB Price:", bnbPrice);
    }
  }, [bnbPrice]);

  const headerFormat = (header) => {
    return (
      <div style={{ color: '#EC599A' }}>
        {header}
      </div>
    );
  }

  const [visible, setVisible] = useState(false);

  const dialogFooter = <div className="p-d-flex p-jc-center">Loading your fun-filled experience...</div>;


  return (
    <div style={{
      background: 'radial-gradient(circle, rgba(4, 0, 255, 0.35) 0%, rgba(0, 0, 0, 0) 75%)',
      // minHeight: '100vh', // Ensure it covers the full viewport height
      // display: 'flex',
      // flexDirection: 'column',
      // alignItems: 'center',
      // justifyContent: 'center',
    }}>
      {isWalletConnected()
        ? (
          loading && !initialLoadDone
            ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Loading type="points" size="lg" />
              </div>
            ) : (
              data?.tokensListRp && (
                <div style={{ marginBottom: '50px' }}>
                  <Toast ref={toast} />
                  <Wallet
                    tokenSelections={data?.tokensListRp}
                    refreshData={getData}
                    imageReferences={data?.dbData}
                    bnbPrice={bnbPrice}
                    setPauseRefresh={setPauseRefresh}
                  />
                </div>
              )
            )
        )
        : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', marginTop: '20px', marginLeft: '20px', marginRight: '20px' }}>
            <RenderSplashScreen />
          </div>
        )}
    </div>
  );

};

export default React.memo(Radar);
